var FormClaims = ( function($) {

    var FormClaims = function(options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];

        that.selectors = {
            claims_passenger: '.js-claims-passenger',
            claims_passenger_index: '.js-claims-passenger-index',
            claims_passenger_remove_button: '.js-claims-passenger-remove-button',
            claims_passenger_add_button: '.js-claims-passenger-add-button',

            claims_passenger_full_name: '.js-claims-passenger-full-name',
            claims_passenger_ticket_number: '.js-claims-passenger-ticket-number',
        }
        
        that.select_toggle_claim_type = '.js-toggle-claim-type';
        that.select_toggle_claim_subtype = '.js-toggle-claim-subtype';
        
        that.select_claim_subtype = '.js-claim-subtype';
        that.$claim_subtype = that.$wrapper.find(that.select_claim_subtype);

        that.input_files = '.js-file-elem';

        that.$el_claim_type_checked = that.$wrapper.find('.js-claim-type-checked');
        that.$el_claim_type_doc = that.$wrapper.find('.js-claim-type-doc');

        that.$block_claims_passenger = that.$wrapper.find(that.selectors.claims_passenger);
        that.$copied_claims_passenger_template = that.$block_claims_passenger.clone();

        // DYNAMIC VARS
        that.locales = options['locales'] || {};
        that.types_options = options['types_options'] || {};
        that.redirect_urls = options['redirect_urls'] || {};
        
        // CONST
        that.max_passengers = 9;

        // INIT
        that.init(options);
    };

    var Self = FormClaims;
    Self.className = 'FormClaims';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id;

            that.$wrapper.find('.js-form-claims').hide();
            that.$wrapper.find('.js-success-result').show();
            that.$wrapper.find('.js-unique-id').text(unique_id);

            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }

        Parent.prototype.init.call(that, options);

        that.initToggles();

        that.initInputMask();

        that.initGroups();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            ...that.selectors,
            form: '.js-form-claims',
            previous_action: '', //TODO: set this when other password restoration methods would be done
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initINN(that.$wrapper);
        UIInputMask.prototype.initBIK(that.$wrapper);
        UIInputMask.prototype.initAccountNumber(that.$wrapper);
        UIInputMask.prototype.initPnrMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initDateMask(that.$wrapper);
        UIInputMask.prototype.initTimeMask(that.$wrapper);
        UIInputMask.prototype.initTicketNumber(that.$wrapper);
    }

    Self.prototype.initToggles = function () {
        var that = this;
        that.initClaimTypeToggle();
        that.initClaimSubtypeToggle();
    }

    Self.prototype.initClaimTypeToggle = function () {
        var that = this;
        $.sa.$document.on('change', that.select_toggle_claim_type, function (e) {
            var $toggle_select = $(e.target),
                selected_type = $toggle_select.val(),
                subtypes_options = that.types_options[selected_type] || { children: {} },
                array_options = Object.keys(subtypes_options.children || {}).map((key) => ({ value: key, label: subtypes_options.children[key] }));

            if (selected_type && $toggle_select.hasClass(that.select_toggle_claim_type.substring(1))) {
                // редирект
                if (that.redirect_urls[selected_type]) {
                    $.sa.content_router.load(that.redirect_urls[selected_type]);
                    return;
                }

                that.$el_claim_type_doc.hide();
                that.$el_claim_type_checked.hide();

                UISelect.prototype.__clearValue(that.$claim_subtype);

                that.$wrapper.find(that.input_files).attr('name', 'files[]');

                if (array_options.length === 0) {
                    that.$el_claim_type_doc.show();

                    return;
                }

                that.$el_claim_type_checked.show();
                
                // Добавляем опции в селектор
                UISelect.prototype.makeOptionsFromArray(that.$claim_subtype, array_options);
            }

        });
    }

    Self.prototype.initClaimSubtypeToggle = function () {
        var that = this;
        $.sa.$document.on('change', that.select_toggle_claim_subtype, function (e) {
            var $toggle_select = $(e.target),
                selected_type = $toggle_select.val();

            if (selected_type && $toggle_select.hasClass(that.select_toggle_claim_subtype.substring(1))) {
                that.$el_claim_type_doc.show();

                that.$wrapper.find(that.input_files).attr('name', 'files[]');
            }

        });
    }

    
    Self.prototype.initGroups = function () {
        var that = this;

        that.setIndexInRoute = function () {
            var $claims_passenger_blocks = that.$wrapper.find(that.selectors.claims_passenger);
            $claims_passenger_blocks.each(function (index) {
                var set_index = index + 1,
                    $block = $(this);

                $block.find(that.selectors.claims_passenger_index).text(set_index === 1 ? '' : '№' + set_index);
                $block.find(that.selectors.claims_passenger_full_name).attr('name', 'passenger[' + set_index + '][full_name]');
                $block.find(that.selectors.claims_passenger_ticket_number).attr('name', 'passenger[' + set_index + '][ticket_number]');

                if (set_index === that.max_passengers) {
                    var $button = $block.find(that.selectors.claims_passenger_add_button);
                    $button.hide();
                }
            })
        }

        that.initGroupBlocks(
            that.selectors.claims_passenger,
            that.selectors.claims_passenger_add_button,
            that.selectors.claims_passenger_remove_button,
            that.$copied_claims_passenger_template,
            function () {
                UIInputMask.prototype.initTicketNumber(that.$wrapper);
                that.setIndexInRoute();
            }
        )
    }

    return Self;
})(jQuery);